import PageSEO from '@/components/feature/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { faqData } from '@/mocks/data';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '年轻的朋友韩国 - 首页',
  description: '专为年轻人打造的韩国旅行指南平台，提供韩国自由行攻略、美食推荐、购物指南与追星路线',
  url: 'https://kpoppath.github.io',
  isPartOf: {
    '@type': 'WebSite',
    name: '年轻的朋友韩国',
    url: 'https://kpoppath.github.io',
  },
  about: {
    '@type': 'TravelAgency',
    name: '年轻的朋友韩国',
    description: '专为年轻人打造的韩国旅行指南',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="专为年轻人打造的韩国旅行指南"
        description="年轻的朋友韩国，为热爱韩流文化的年轻人提供最全面的韩国旅行攻略、美食推荐、购物指南与追星路线。无论是首尔街头漫步还是济州岛探险，年轻的朋友韩国助你玩转韩国每一个精彩角落。"
        keywords="年轻的朋友韩国,年轻人韩国旅游攻略,韩国自由行推荐,首尔网红打卡地,韩国购物美食指南,韩流文化体验,韩国追星路线"
        canonicalUrl="/"
        schema={{ ...homeSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}